import Vue from 'vue'
import Vuex from 'vuex'
import { auth } from './auth.module'
import { companies } from './companies.module'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  getters: {},
  modules: {
    auth,
    companies,
  },
})
